"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouch = void 0;
var isTouch = function () { return "ontouchstart" in document.documentElement; };
exports.isTouch = isTouch;
//# sourceMappingURL=isTouch.js.map